module.exports = __webpack_public_path__ + "static/media/copy-share-link.d68f91fa.gif";